import type { Media } from '../../payload-types';

/**
 * The stored blur placeholder, but only for an image with no transparent
 * pixels (`opaque === true`); `undefined` otherwise, including a cleared or
 * never-generated placeholder.
 *
 * Both renderers draw the blur behind the image and neither can take it away
 * before the image paints over it: `renderArtDirectedPicture`'s raw `<img>`
 * never removes it, and Next's `<Image>` (what `MediaElement` renders) removes
 * it through React state, i.e. only after hydration — and opted-in images are
 * mostly preloaded heroes that finish loading first. Behind an opaque photo the
 * blur is invisible; behind a transparent cut-out it would show through as a
 * halo until hydration, and for good if the JS never runs.
 *
 * Imports nothing but the `Media` type: client components use it.
 */
export const opaqueBlurDataURL = (m: Media): string | undefined =>
  m.placeholder?.opaque === true && m.placeholder.blurDataURL ? m.placeholder.blurDataURL : undefined;
